import { FormControl, ValidationErrors } from '@angular/forms';

export abstract class FormUtil {
  /**
   * Mark a control such that it will be forced to show errors.
   *
   * @param control The control to mark
   */
  public static showErrors(control: FormControl): void {
    control.markAsTouched();
    control.markAsDirty();
  }

  /**
   * Mark errors on a control such that it will be forced to show one of those errors.
   *
   * @param control The control to mark
   * @param errors The errors to mark on the control
   */
  public static forceError(control: FormControl, errors: ValidationErrors): void {
    control.setErrors(errors);
    this.showErrors(control);
  }
}
